<div class="container">
    <div class="initial-state justify-center">
        <form [formGroup]="codesForm">
            <mat-form-field appearance="outline" color="accent">
                <mat-label>Select Brand</mat-label>
                <mat-select (selectionChange)="checkBrandId()" formControlName="brandId">
                    <mat-option *ngFor="let brand of brands" [value]="brand.id">{{ brand.name }}</mat-option>
                </mat-select>
            </mat-form-field>
        </form>

        <div *ngIf="coinsData.length">
            <h3>Datos del código:</h3>
            <ul>
                <li *ngFor="let data of coinsData">{{ data.amount }} códigos restantes. </li>
            </ul>
        </div>

        <div *ngIf="userData.length">
            <h3>Usuarios que han escaneado el código ({{userData.length}}):</h3>
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Image</th>
                        <th>Name</th>
                        <th>Transaction Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of userData">
                        <td><img *ngIf="user.photoURL" [src]="user.photoURL" [alt]="user.displayName" style="width: 50px; height: 50px; border-radius: 50%;"></td>
                        <td>{{ user.displayName }}</td>
                        <td>{{ user.timestamp| date: 'short' }}</td> 
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<div class="loading" *ngIf="isLoading">
    <mat-spinner color="accent" diameter="40">

    </mat-spinner>
</div>
